/* eslint-disable array-callback-return */

import * as React from "react";
import { withTranslation } from "react-i18next";
import i18n from "../../i18n";
import { StyledModal } from "../modal/StyledModal";
import Datalist, { ListColumn } from "../Datalist/Datalist";
import {  IInvoiceDataForPieChart } from "../../services/API/DashBoard";
import { Button, Spinner, Stack } from "react-bootstrap";
import CsvDownloader from "react-csv-downloader";
import { ReadFriendlyNumber } from "../../lib/utils";
import { DataService } from "../../services/DataService";

interface ICategoryModalProps {
    selectedAcademicYear:{period:string,typeOfEvent:string};
  onDissmissHandler: () => void;
}
interface ICategoryModalState {
  loading: boolean;
  columns: ListColumn<IInvoiceDataForPieChart> | any;
  data:any;
}

class AcademicyearModal extends React.Component<
  ICategoryModalProps,
  ICategoryModalState
> {
  date = new Date().toLocaleDateString("sv-SE");
  columns: ListColumn<IInvoiceDataForPieChart>[] = [
    // {
    //   fieldName: "contractId",
    //   isActive: true,
    //   key: "contractId",
    //   minWidth: 50,
    //   maxWidth: 100,
    //   sorting: true,
    //   name: i18n.t('dashboard.contractId'),
     
    // },
 
    {
      fieldName: "supplierOrgId",
      isActive: true,
      key: "supplierOrgId",
      minWidth: 100,
      maxWidth: 140,
      sorting: true,
      name: i18n.t("dashboard.supplierOrgId"),
    },
    {
      fieldName: "supplierName",
      isActive: true,
      key: "supplierName",
      minWidth: 100,
      maxWidth: 140,
      sorting: true,
      name: i18n.t("dashboard.supplierName") ,
    },
    {
      fieldName: "period",
      isActive: true,
      key: "period",
      minWidth: 100,
      maxWidth: 140,
      sorting: true,
      name:i18n.t("dashboard.period") ,
    },
    
  
    
  ];
  constructor(props: ICategoryModalProps) {
    super(props);
    this.state = { loading: true, columns: this.columns ,data:[]};
  }
  componentDidMount(): void {
    this.setState({ loading: true }, async() => {
       const result = await DataService.Dashboard.GetAcademicYear(this.props.selectedAcademicYear.period,this.props.selectedAcademicYear.typeOfEvent);
       if(result)
            this.setState({data:result});
       
       this.setState({loading:false});
    });
  }

  render() {
    
    return (
      <div>
       
          <StyledModal
          
          headerStyle={{backgroundColor:'#173c53',color:'white'}}
            title={`${this.props?.selectedAcademicYear?.typeOfEvent}`}
            className="full-width"
            onDismiss={
              () => this.props.onDissmissHandler() 
            }
            body={
              <div style={{ maxHeight: "26vh" }}>
                {this.state.loading ? <div style={{ float: "right", marginLeft: "10px" }}>
            <Spinner />
          </div>:
            <Datalist
                  items={this.state.data ?? []}
                  uniqueKey="invoiceNumber"
                  columns={this.state.columns}
                  noItemsText={
                    i18n.t('dashboard.noCategories') 
                  }
                  initialSortKey="billingDate"
                  descendingSort={false}
                  setColumns={(cols) => this.setState({ columns: cols })}
                  
                />
          }
                
               
              </div>
            }
            footer={
              <Stack direction="horizontal" gap={2}>
                <CsvDownloader
                  datas={this.state.data as any}
                  extension=".csv"
                  filename={`${
                   this.props.selectedAcademicYear}`}
                  separator=";"
                >
                  <Button className="primary">
                    {i18n.t("print.exportButton")}
                  </Button>
                </CsvDownloader>

                <Button
                  className="button button-cancel"
                  onClick={this.props.onDissmissHandler}
                >
                  {i18n.t("dashboard.closeButton")}
                </Button>
              </Stack>
            }
          />
        
      </div>
    );
  }
}

export default withTranslation()(AcademicyearModal);
